import { Directive, ElementRef, Input, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[lumTableAnimateRow]',
})
export class TableAnimateRowDirective {
  @Input() lumTableAnimateRow :any;

  constructor(
    private el :ElementRef,
    private renderer :Renderer2,
  ) {}

  ngOnInit() {
    if (this.lumTableAnimateRow) {
      this.renderer.addClass(this.el.nativeElement, 'fade-in-out');
      setTimeout(() => {
        this.renderer.removeClass(this.el.nativeElement, 'fade-in-out');
      }, 3000);
    }
  }

  slideOut() {
    this.renderer.addClass(this.el.nativeElement, 'slide-out');
  }
}
